import React from "react";
import ModalContainer from "Components/Common/Modal/ModalContainer";
import FillButton from "Components/Common/components/Button/FillButton";
import BorderedButton from "Components/Common/components/Button/BorderedButton";
import { CANCEL } from "../ARSConstants";
import { ModalFooter, ModalHeader } from "react-bootstrap";

const PromotionModal = ({ showModal, closeModal, onConfirm }: any) => {
    return (
        <ModalContainer
            isOpen={showModal}
            setOpen={closeModal}>
            <ModalHeader>
                <div className="tw-font-bold">
                    Promote Model

                </div>
            </ModalHeader>

            <div >
                <label className="tw-m-4 tw-mb-0">
                    coming Soon
                </label>
            </div>

            <ModalFooter>
                <div className="tw-flex tw-max-w-full tw-w-full tw-justify-end tw-items-center tw-space-x-3">
                    <BorderedButton onClick={() => closeModal()}>{CANCEL}</BorderedButton>
                    <FillButton className={`!tw-border-red-500 !tw-cursor-pointer !tw-bg-red-500 hover:!tw-bg-primary-hover hover:!tw-border-primary-hover`} onClick={() => onConfirm()} disabledClassName="!tw-border-red-200 !tw-bg-red-200">Promote</FillButton>
                </div>
            </ModalFooter>
        </ModalContainer>

    )
}

export default PromotionModal;